import { useCallback } from 'react'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import ExperienceLuxPlusCarousel from 'components/Experiences/ExperienceLists/ExperienceLuxPlusCarousel'

/**
 * Same underlying carousel as the LuxPlus+ landing page's experiences carousel
 * (ExperienceLuxPlusCarousel — same place resolution, same offers, same hideWhenEmpty behaviour)
 * with our own campaign-specific title, and no subtitle.
 */
function LuxPlusMonthTakeoverExperienceOffersCarousel() {
  const renderItalic = useCallback((chunks: ReactNode) => <i>{chunks}</i>, [])

  return (
    <ExperienceLuxPlusCarousel
      title={(
        <FormattedMessage
          id="wqDM79tLQDdZj3bOWgnJ"
          defaultMessage="<i>Save more</i> on local experiences"
          description="Section title for the LuxPlus+ Month campaign landing page experiences carousel, with 'Save more' shown in italics"
          values={{ i: renderItalic }}
        />
      )}
      subtitle=""
    />
  )
}

export default LuxPlusMonthTakeoverExperienceOffersCarousel
